<template>
  <div>
    <!-- 导入对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="upload.open"
      width="400px"
      append-to-body
    >
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="headers"
        :action="url"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :on-error="handleFileError"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip text-center" slot="tip">
          <span>仅允许导入xls、xlsx格式文件。</span>
          <el-link
            type="primary"
            :underline="false"
            style="font-size:12px;vertical-align: baseline;"
            @click="downExcelTemp"
            v-if="tempUrl"
          >下载模板
          </el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>

    <!--校验失败错误数据-->
    <el-dialog title="校验失败数据" :visible.sync="errorVisible">
      <el-table :data="errorData">
        <el-table-column
          property="lineNum"
          label="行号"
          width="50"
        ></el-table-column>
        <el-table-column
          property="errors"
          label="错误描述"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag
              type="danger"
              v-for="error in scope.row.errors"
              :key="error"
            >{{ error }}
            </el-tag
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";
import preconditionDialog from "@/views/dialogCommon/chanPinDialog";
import pager from "@/components/pager";
import orderDialog from "@/views/dialogCommon/radioOrderDialog";

export default {
  name: "ExcelUpload",
  components: { preconditionDialog, pager, orderDialog },
  props: {
    url: {
      type: String
    },
    title: {
      type: String
    },
    tempUrl: {
      type: String
    }
  },
  data() {
    return {
      upload: {
        open: false,
        isUploading: false
      },
      errorVisible: false,
      errorData: []
    };
  },
  computed: {
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },
  methods: {
    downExcelTemp() {
      this.downBlobFile(this.tempUrl, {}, this.title+".xlsx");
    },
    handleFileUploadProgress() {
      this.upload.isUploading = true;
    },
    handleFileError(response) {
      //Error: {"code":1,"msg":"最多导入100条工单","data":null,"objx":null,"hitCount":false,"content":null,"rmid":null,"time":"2024-01-09 11:09:05","type":"error"}
      console.log("数据异常:",response)
      let myError = response.toString();//转字符串
      console.log("数据异常2:",myError)
      myError=myError.replace("Error: ","") // 去掉前面的" Error: "
      console.log("数据异常3:",myError)
      myError=JSON.parse(myError);//转对象
      console.log("数据异常4:",myError)
      this.$message.error(myError.msg)
      this.upload.open = false;
      this.$mask.close()
    },

    handleFileSuccess(response) {
      this.upload.isUploading = false;
      this.upload.open = false;
      this.$refs.upload.clearFiles();

      // 校验失败
      if (response.code === 1) {
        if (response.data) {
          console.log("校验失败异常:",response)
          this.$message.error('导入失败，以下数据不合法')
          this.errorVisible = true;
          this.errorData = response.data;
          this.$refs.upload.clearFiles();
        }else{
          this.$message.error(response.msg);
        }
      } else {
        this.$message.success(response.msg ? response.msg : "导入成功");
        // 刷新表格
        this.$emit("refreshDataList", response.data);
      }

      this.$mask.close()
    },
    submitFileForm() {
      if (this.$refs.upload.uploadFiles.length === 0) {
        this.$message.error('请上传文件');
        return
      }

      this.$mask.open()
      this.$refs.upload.submit();
    },
    show() {
      this.upload.isUploading = false;
      this.upload.open = true;
    }
  }
};
</script>
